import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const activeShutdownsKey = {
  main: () => 'activeRequestShutdowns',
  byHouseId: (houseId) => [activeShutdownsKey.main(), houseId],
};

const activeShutdownsQuery = async ({ queryKey }) => {
  const [_, houseId] = queryKey;

  return await request.get(
    `/Alert`,
    { houses: houseId, onlyActive: true },
    `При загрузке активных отключений произошла ошибка`
  );
};

export const useActiveShutdowns = (houseId, options) =>
  useQuery(
    activeShutdownsKey.byHouseId(houseId),
    activeShutdownsQuery,
    options
  );
